'use client';

import React from 'react';
import { canUseDOM } from '@/app/common/utils/canUseDOM';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const dynamicImportCatch = (): { default: () => React.ReactElement<any> } => {
  if (canUseDOM) {
    window.location.reload();
  }
  return { default: () => <div /> };
};
